<div class="searchBox" [ngClass]="{ ar: translate.currentLang == 'ar' }">
  <form [formGroup]="searchbox.searchFlight">
    <div class="container-fluid container-for-result">
      <div class="row align-items-center">
        <ng-container formArrayName="Flights">
          <ng-container
            *ngFor="
              let item of searchbox.flightsArray['controls'] | slice: 0 : 1;
              let i = index
            "
          >
            <ng-container [formGroupName]="0">
              <!-- Depart City web -->
              <div *ngIf="sharedService.screenWidth >= 650" class="inputWidth firstInput">
                <mat-form-field
                  color="accent"
                  class="searchboxInput"
                  appearance="outline"
                >
                  <p
                    class="cityInputPlacholder"
                    [ngStyle]="{
                      color: searchbox.searchBoxValidation(0) ? 'red' : '',
                    }"
                  >
                    <ng-container *ngIf="searchbox.searchBoxValidation(0)"
                      >*</ng-container
                    >
                    {{ "searchbox.leaveFrom" | translate }}
                  </p>
                  <!-- Depart Input -->
                  <div class="d-flex">
                    <input
                      onClick="this.select();"
                      formControlName="departing"
                      type="text"
                      class="input"
                      aria-label="City"
                      matInput
                      [matAutocomplete]="autoa"
                      #firstD
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('departing')?.value
                          ? onCitySearch(item.get('departing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                    <i
                      class="bi bi-x closeIcon"
                      (click)="firstD.value = ' '; removeInput('depart', i)"
                    ></i>
                  </div>

                  <!-- Depart Airports -->
                  <mat-autocomplete #autoa="matAutocomplete">
                    <ng-container *ngIf="sharedService.cities != undefined">
                      <mat-option
                        *ngFor="
                          let city of sharedService.cities
                            | filterCity: item.get('departing')?.value : sharedService.lang
                            | limitTo: 5
                        "
                        (onSelectionChange)="onSelectDepartingCity(city)"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                      >
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportName
                              | highlighter: item.get('departing')?.value
                          "
                        ></span>
                        -
                        <span
                          [innerHTML]="
                            city[sharedService.lang].countryName
                              | highlighter: item.get('departing')?.value
                          "
                        ></span>
                        (
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportCode
                              | highlighter: item.get('departing')?.value
                          "
                        ></span>
                        )
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </mat-form-field>

                <!-- Switch Arrow -->
                <div
                  class="switchArrow"
                  (click)="searchbox.switchDestination(item, 0)"
                >
                  <img src="../../../../assets/icons/SwitchIcon.svg" />
                </div>
              </div>

              <ng-template #depart let-modal>
                <div class="modal-header">
                  <div class="row d-flex justify-content-between p-3">
                    <div class="col-6 modal-header-text">
                      {{
                        translate.currentLang == "en"
                          ? "Leaving from"
                          : "المغادرة من"
                      }}
                    </div>

                    <button
                      type="button"
                      class="btn-close m-0"
                      aria-label="Close"
                      (click)="modal.dismiss('Cross click')"
                    ></button>
                  </div>
                  <div class="row mt-2">
                    <input
                      onClick="this.select();"
                      id="departInput"
                      formControlName="departing"
                      type="text"
                      class="form-control modal-input"
                      aria-label="City"
                      (input)="onSearchInputChange($event)"
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('departing')?.value
                          ? onCitySearch(item.get('departing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                  </div>
                </div>
                <div class="modal-body">
                  <!-- Depart Airports -->
                  <ng-container *ngIf="sharedService.cities != undefined">
                    <app-skeleton-airport-list
                      *ngIf="isLoading"
                    ></app-skeleton-airport-list>
                    <ng-container *ngIf="!isLoading">
                      <mat-option
                        *ngFor="
                          let city of sharedService.cities
                            | filterCity: item.get('departing')?.value : sharedService.lang
                            | limitTo: 5
                        "
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                        (click)="
                          assignCountriesForMobileD(
                            city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                            i,
                            city
                          )
                        "
                      >
                        <div class="airportFormat">
                          <span class="me-2"
                            ><img
                              src="../../../../../assets/images/depart-icon.png"
                              width="30px"
                            />
                          </span>
                          <span class="code">
                            (
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportCode
                                  | highlighter: item.get('departing')?.value
                              "
                            ></span>
                            )
                          </span>
                          <span
                            [innerHTML]="
                              city[sharedService.lang].airportName
                                | highlighter: item.get('departing')?.value
                            "
                          ></span>
                          -
                          <span
                            [innerHTML]="
                              city[sharedService.lang].countryName
                                | highlighter: item.get('departing')?.value
                            "
                          ></span>
                        </div>
                      </mat-option>
                    </ng-container>
                    <ng-template #recommendedAirports>
                      <div class="title ms-2">
                        <span class="me-2">
                          <img
                            src="../../../../../assets/images/destination.png"
                            width="30px" /></span
                        >{{
                          translate.currentLang == "en"
                            ? "Popular Destinations"
                            : " وجهات مشهورة"
                        }}
                      </div>
                      <mat-option
                        *ngFor="let city of getRecommendedAirports()"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                        (click)="
                          assignCountriesForMobileD(
                            city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                            i,
                            city
                          )
                        "
                      >
                        <div class="airportFormat">
                          <span class="me-2"
                            ><img
                              src="../../../../../assets/images/depart-icon.png"
                              width="30px"
                            />
                          </span>
                          <span class="code">
                            (
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportCode
                                  | highlighter: item.get('departing')?.value
                              "
                            ></span>
                            )
                          </span>
                          <span
                            [innerHTML]="
                              city[sharedService.lang].airportName
                                | highlighter: item.get('departing')?.value
                            "
                          ></span>
                          -
                          <span
                            [innerHTML]="
                              city[sharedService.lang].countryName
                                | highlighter: item.get('departing')?.value
                            "
                          ></span>
                        </div>
                      </mat-option>
                    </ng-template>
                  </ng-container>
                </div>
              </ng-template>

              <!-- Land City  for web -->
              <div
                *ngIf="sharedService.screenWidth >= 650"
                class="inputWidth"
                (click)="showDate()"
              >
                <mat-form-field
                  color="accent"
                  class="searchboxInput"
                  appearance="outline"
                >
                  <p
                    class="cityInputPlacholder"
                    [ngStyle]="{
                      color: searchbox.searchBoxValidation(0) ? 'red' : '',
                    }"
                  >
                    <ng-container *ngIf="searchbox.searchBoxValidation(0)"
                      >*</ng-container
                    >
                    {{ "searchbox.goingTo" | translate }}
                  </p>
                  <!-- Land Inputs -->
                  <div class="d-flex">
                    <input
                      onClick="this.select();"
                      formControlName="landing"
                      type="text"
                      class="input"
                      aria-label="City"
                      matInput
                      [matAutocomplete]="autob"
                      #firstAr
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('landing')?.value
                          ? onCitySearch(item.get('landing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                    />
                    <i
                      class="bi bi-x closeIcon"
                      (click)="firstAr.value = ' '; removeInput('land', i)"
                    ></i>
                  </div>
                  <!-- Land Airports -->
                  <mat-autocomplete #autob="matAutocomplete">
                    <ng-container *ngIf="sharedService.cities != undefined">
                      <mat-option
                        *ngFor="
                          let city of sharedService.cities
                            | filterCity: item.get('landing')?.value : sharedService.lang
                            | limitTo: 5
                        "
                        (onSelectionChange)="onSelectLandingCity(city)"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                      >
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportName
                              | highlighter: item.get('landing')?.value
                          "
                        ></span>
                        -
                        <span
                          [innerHTML]="
                            city[sharedService.lang].countryName
                              | highlighter: item.get('landing')?.value
                          "
                        ></span>
                        (
                        <span
                          [innerHTML]="
                            city[sharedService.lang].airportCode
                              | highlighter: item.get('landing')?.value
                          "
                        ></span>
                        )
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <ng-template #landing let-modal>
                <div class="modal-header">
                  <div class="row d-flex justify-content-between p-3">
                    <div class="col-6 modal-header-text">
                      {{
                        translate.currentLang == "en"
                          ? "Going to"
                          : "الوصول الى"
                      }}
                    </div>

                    <button
                      type="button"
                      class="btn-close m-0"
                      aria-label="Close"
                      (click)="modal.dismiss('Cross click')"
                    ></button>
                  </div>
                  <div class="row mt-2">
                    <input
                      onClick="this.select();"
                      formControlName="landing"
                      type="text"
                      id="landingInput"
                      class="form-control modal-input"
                      (input)="onCitySearch($event)"
                      (focus)="
                        item.get('landing')?.value
                          ? onCitySearch(item.get('landing')?.value)
                          : (sharedService.cities = getRecommendedAirports())
                      "
                      aria-label="City"
                      matInput
                      #firstD
                    />
                  </div>
                </div>
                <div class="modal-body">
                  <!--landing Airports -->
                  <ng-container *ngIf="sharedService.cities != undefined">
                    <app-skeleton-airport-list
                      *ngIf="isLoading"
                    ></app-skeleton-airport-list>
                    <ng-container *ngIf="!isLoading">
                      <mat-option
                        *ngFor="
                          let city of sharedService.cities
                            | filterCity: item.get('landing')?.value : sharedService.lang
                            | limitTo: 5
                        "
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                        (click)="
                          assignCountriesForMobileA(
                            city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                            i,
                            city
                          )
                        "
                      >
                        <div class="airportFormat">
                          <span class="me-2"
                            ><img
                              src="../../../../../assets/images/landing-icon.png"
                              width="30px"
                            />
                          </span>
                          <span class="code">
                            (
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportCode
                                  | highlighter: item.get('landing')?.value
                              "
                            ></span>
                            )
                          </span>
                          <span
                            [innerHTML]="
                              city[sharedService.lang].airportName
                                | highlighter: item.get('landing')?.value
                            "
                          ></span>
                          -
                          <span
                            [innerHTML]="
                              city[sharedService.lang].countryName
                                | highlighter: item.get('landing')?.value
                            "
                          ></span>
                        </div>
                      </mat-option>
                    </ng-container>
                    <ng-template #recommendedAirports>
                      <div class="title ms-2">
                        <span class="me-2">
                          <img
                            src="../../../../../assets/images/destination.png"
                            width="30px" /></span
                        >{{
                          translate.currentLang == "en"
                            ? "Popular Destinations"
                            : " وجهات مشهورة"
                        }}
                      </div>
                      <mat-option
                        *ngFor="let city of getRecommendedAirports()"
                        [value]="city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode"
                        (click)="
                          assignCountriesForMobileA(
                            city[sharedService.lang].cityName + ',' + city[sharedService.lang].airportCode,
                            i,
                            city
                          )
                        "
                      >
                        <div class="airportFormat">
                          <span class="me-2"
                            ><img
                              src="../../../../../assets/images/landing-icon.png"
                              width="30px"
                            />
                          </span>
                          <span class="code">
                            (
                            <span
                              [innerHTML]="
                                city[sharedService.lang].airportCode
                                  | highlighter: item.get('landing')?.value
                              "
                            ></span>
                            )
                          </span>
                          <span
                            [innerHTML]="
                              city[sharedService.lang].airportName
                                | highlighter: item.get('landing')?.value
                            "
                          ></span>
                          -
                          <span
                            [innerHTML]="
                              city[sharedService.lang].countryName
                                | highlighter: item.get('landing')?.value
                            "
                          ></span>
                        </div>
                      </mat-option>
                    </ng-template>
                  </ng-container>
                </div>
              </ng-template>

              <div
                class="d-flex gap-2 position-relative"
                *ngIf="sharedService.screenWidth < 650"
              >
                <app-mobile-input
                  class="flex-grow-1 mobileWidth"
                  (inputClick)="openDepartAirport(depart)"
                  [isNotValid]="searchbox.searchBoxValidation(0)"
                >
                  <input
                    [ngStyle]="{ display: 'none' }"
                    formControlName="departing"
                    #firstD
                    #mobileIssuedCountryDepart
                    (input)="onCitySearch($event)"
                    (focus)="
                      item.get('departing')?.value
                        ? onCitySearch(item.get('departing')?.value)
                        : (sharedService.cities = getRecommendedAirports())
                    "
                  />

                  <p class="cityInputPlacholder">
                    {{ "searchbox.leaveFrom" | translate }}
                  </p>

                  <div
                    class="airport"
                    *ngIf="sharedService.departingAirports[0]"
                  >
                    <span class="airport__city-name">
                      {{ sharedService.departingAirports[0][sharedService.lang].cityName }}
                    </span>

                    <span class="airport__airport-name">
                      {{ sharedService.departingAirports[0][sharedService.lang].airportName }}
                    </span>
                  </div>

                  <div
                    class="airport"
                    *ngIf="!sharedService.departingAirports[0]"
                  >
                    <span class="airport__city-name">
                      {{ "searchbox.fromAirport" | translate }}
                    </span>
                  </div>
                </app-mobile-input>

                <div
                  class="switch-arrow-mobile"
                  (click)="searchbox.switchDestination(item, 0)"
                >
                  <img src="assets/icons/switch-icon-mobile.svg" />
                </div>
                <app-mobile-input
                  class="flex-grow-1 mobileWidth"
                  (inputClick)="openLandingAirport(landing)"
                  [isNotValid]="searchbox.searchBoxValidation(0)"
                >
                  <input
                    [ngStyle]="{ display: 'none' }"
                    formControlName="landing"
                    #firstD
                    #mobileIssuedCountryLanding
                    (input)="onCitySearch($event)"
                    (focus)="
                      item.get('landing')?.value
                        ? onCitySearch(item.get('landing')?.value)
                        : (sharedService.cities = getRecommendedAirports())
                    "
                  />
                  <p class="cityInputPlacholder">
                    {{ "searchbox.goingTo" | translate }}
                  </p>

                  <div class="airport" *ngIf="sharedService.landingAirports[0]">
                    <span class="airport__city-name">
                      {{ sharedService.landingAirports[0][sharedService.lang].cityName }}
                    </span>

                    <span class="airport__airport-name">
                      {{ sharedService.landingAirports[0][sharedService.lang].airportName }}
                    </span>
                  </div>

                  <div
                    class="airport"
                    *ngIf="!sharedService.landingAirports[0]"
                  >
                    <span class="airport__city-name">
                      {{ "searchbox.toAirport" | translate }}
                    </span>
                  </div>
                </app-mobile-input>
              </div>

              <!-- Form Dates -->
              <div
                class="dateWidth"
                *ngIf="sharedService.screenWidth >= 650; else dateElseCondition"
                (click)="showDate()"
              >
                <div class="d-flex gap-3 dateInputs">
                  <!-- Depart Date -->
                   <div
                    (focus)="onInputFocus('departDate')"
                    [matMenuTriggerFor]="roundTripMenu"
                    
                    #roundTripDCalenderTrigger
                   >
                    <mat-form-field
                      color="accent"
                      appearance="outline"
                      class="searchboxInput"
                    >
                      <p class="cityInputPlacholder">
                        {{ "searchbox.depart" | translate }}
                      </p>
                      <input
                        readonly
                        matInput
                        id="roundTripDCalenderTrigger"
                        value="{{
                          searchbox.flightsArray.at(0).get('departingD')?.value
                            | date: 'MMM dd'
                        }}"
                      />
                    </mat-form-field>
                   </div>

                  <!-- Retrurn Date -->
                   <div
                      (focus)="onInputFocus('returnDate')"
                      [matMenuTriggerFor]="roundTripMenu"
                      #roundTripRCalenderTrigger
                   >
                    <mat-form-field
                      color="accent"
                      appearance="outline"
                      class="searchboxInput"
                    >
                      <p class="cityInputPlacholder">
                        {{ "searchbox.retun" | translate }}
                      </p>
                      <input
                        readonly
                        matInput
                        id="roundTripRCalenderTrigger"
                        value="{{
                          searchbox.searchFlight.controls['returnDate'].value
                            | date: 'MMM dd'
                        }}"
                      />
                    </mat-form-field>
                   </div>
                </div>
              </div>

              <!-- Else Date Condition -->
              <ng-template #dateElseCondition>
                <!-- Depart Date -->

                <div class="d-flex gap-2 mt-2 position-relative">
                  <app-mobile-input
                    class="flex-grow-1 mobileWidth"
                    (inputClick)="showMobileDate(0, 'departDate')"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.depart" | translate }}
                    </p>

                    <p class="fs-6" *ngIf="item.get('departingD')?.value">
                      {{ item.get("departingD")?.value | date: "MMM dd" }}
                    </p>

                    <p class="fs-6" *ngIf="!item.get('departingD')?.value">
                      {{ "searchbox.depDate" | translate }}
                    </p>
                  </app-mobile-input>

                  <div class="calander-mobile">
                    <img src="assets/icons/calander-icon-mobile.svg" />
                  </div>

                  <app-mobile-input
                    class="flex-grow-1 mobileWidth"
                    (inputClick)="showMobileDate(0, 'returnDate')"
                  >
                    <p class="cityInputPlacholder">
                      {{ "searchbox.retun" | translate }}
                    </p>

                    <p
                      class="fs-6"
                      *ngIf="
                        searchbox.searchFlight.controls['returnDate'].value
                      "
                    >
                      {{
                        searchbox.searchFlight.controls["returnDate"].value
                          | date: "MMM dd"
                      }}
                    </p>

                    <p
                      class="fs-6"
                      *ngIf="
                        !searchbox.searchFlight.controls['returnDate'].value
                      "
                    >
                      {{ "searchbox.landingDate" | translate }}
                    </p>
                  </app-mobile-input>
                </div>
              </ng-template>

              <!-- Travelers/Class -->
              <div
                class="travelerWidth"
                (click)="showTravellers()"
                *ngIf="sharedService.screenWidth >= 650; else travelerElseCondition"
              >
                <mat-form-field
                  class="searchboxInput"
                  color="accent"
                  appearance="outline"
                  [matMenuTriggerFor]="menu"
                  (click)="openClass = true"
                >
                  <p class="cityInputPlacholder">
                    {{ "searchbox.traveller" | translate }}
                  </p>
                  <input
                    matInput
                    readonly
                    type="text"
                    value="{{
                      getTotalPassenger() +
                        '/' +
                        (searchbox.searchFlight.controls['class'].value
                          | translate)
                    }}"
                  />
                </mat-form-field>
              </div>

              <!-- Travelers/Class Else Condition -->
              <ng-template #travelerElseCondition>
                <app-mobile-input
                  class="col-12 mt-2 mb-4"
                  (inputClick)="showTravellers(); openClass = true"
                  [matMenuTriggerFor]="menu"
                >
                  <p class="cityInputPlacholder">
                    {{ "searchbox.traveller" | translate }}
                  </p>

                  <p class="fs-6">
                    {{
                      getTotalPassenger() +
                        "/" +
                        (searchbox.searchFlight.controls["class"].value
                          | translate)
                    }}
                  </p>
                </app-mobile-input>
              </ng-template>

              <mat-menu
                #roundTripMenu="matMenu"
                class="calenderMenu"
                (click)="$event.stopPropagation()"
              >
                <div class="datesSummary" (click)="$event.stopPropagation()">
                  <div class="dateSummaryBox"></div>
                </div>
                <ngb-datepicker
                  (click)="$event.stopPropagation()"
                  class="searchBoxPicker"
                  [displayMonths]="1"
                  navigation="arrows"
                  [dayTemplate]="oneway"
                  outsideDays="hidden"
                  [minDate]="minDate"
                  [startDate]="startDateValue"
                  firstDate="startDateValue"
                >
                </ngb-datepicker>

                <ng-template #oneway let-date let-focused="focused">
                  <span
                    (click)="onDateSelection(date)"
                    (click)="closeCalander()"
                    class="custom-day"
                    [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)"
                    [class.disabled]="isDisabled(date)"
                    (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null"
                  >
                    {{ date.day | translate }}
                  </span>
                </ng-template>
              </mat-menu>

              <div class="submitBtn" *ngIf="!InFlightResult()">
                <button class="submit-btn" (click)="submit()">
                  {{ "searchbox.search" | translate }}
                </button>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div
        class="col-lg-2 col-md-4 col-sm-4 button-in-result"
        *ngIf="InFlightResult()"
      >
        <button class="submit-btn" (click)="submit()">
          {{ "searchbox.search" | translate }}
        </button>
      </div>
    </div>
  </form>
  <!--Submit Button -->
</div>
<!-- Travellers menu -->
<mat-menu #menu="matMenu">
  <div class="travellersAndClassMenu">
    <form [formGroup]="searchbox.searchFlight">
      <ng-container formGroupName="passengers">
        <div class="travel" (click)="stopMenuClosing($event)">
          <div class="travellersTypes" (click)="$event.stopPropagation()">
            <div class="type">
              <div class="typeText">
                {{ "searchbox.adults" | translate }}
                <p class="subT">{{ "searchbox.adultsNum" | translate }}</p>
              </div>
              <div class="typeControl">
                <span class="decreaseBtn" (click)="changeAdultValue('decrease')"
                  >-</span
                >
                <span class="typeValue">{{
                  searchbox.searchFlight.get("passengers")?.get("adults")?.value
                }}</span>
                <span class="increaseBtn" (click)="changeAdultValue('increase')"
                  >+</span
                >
              </div>
            </div>

            <div class="type">
              <div class="typeText">
                {{ "searchbox.children" | translate }}
                <p class="subT">{{ "searchbox.childrenNum" | translate }}</p>
              </div>

              <div class="typeControl">
                <span class="decreaseBtn" (click)="changeChildValue('decrease')"
                  >-</span
                >
                <span class="typeValue">{{
                  searchbox.searchFlight.get("passengers.child")?.value
                }}</span>
                <span class="increaseBtn" (click)="changeChildValue('increase')"
                  >+</span
                >
              </div>
            </div>

            <div class="type">
              <div class="typeText">
                {{ "searchbox.infants" | translate }}
                <p class="subT">{{ "searchbox.infantsNum" | translate }}</p>
              </div>

              <div class="typeControl">
                <span
                  class="decreaseBtn"
                  (click)="changeInfantValue('decrease')"
                  >-</span
                >
                <span class="typeValue">{{
                  searchbox.searchFlight.get("passengers.infant")?.value
                }}</span>
                <span
                  class="increaseBtn"
                  (click)="changeInfantValue('increase')"
                  >+</span
                >
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <mat-form-field
        appearance="outline"
        color="accent"
        *ngIf="openClass"
        (click)="$event.stopPropagation()"
      >
        <!-- <mat-label>{{"searchFlight.class"|translate}}</mat-label> -->
        <mat-select formControlName="class" value="Economy">
          <mat-option
            value="Economy"
            selected
            [ngClass]="{ rtlOption: translate.currentLang == 'ar' }"
          >
            {{ "searchbox.economy" | translate }}
          </mat-option>

          <mat-option
            value="Business"
            [ngClass]="{ rtlOption: translate.currentLang == 'ar' }"
          >
            {{ "searchbox.business" | translate }}
          </mat-option>
          <mat-option
            value="First"
            [ngClass]="{ rtlOption: translate.currentLang == 'ar' }"
          >
            {{ "searchbox.first" | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-menu>
